export default __webpack_public_path__ + "static/media/background.c5e132f1.png";